<template>
  <div id="myaccount" class="inner">
    <innertopbar @close="close()">
      <template v-slot:breadcrumb>
        My Account 
       
      </template>

      <template v-slot:listitems>
         <li class="inline-block">
          <button
            @click="logout()"
            type="button"
            class="publish-button bg-red-600 hover:bg-opacity-75"
          >
            Logout
            
          </button>
        </li>
      </template>
    </innertopbar>

    <div v-if="errored" class="m-5 px-6">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Account details</p>
      </div>

        <div
          class="p-4 pl-10 w-[680px] rounded-xl group sm:flex space-x-6 
          bg-white rounded-2xl p-6 mt-6 mx-auto w-10/12"
        >
          <div class="sm:w-full pl-0 p-2">
            <div class="space-y-4">
              <div class="flex justify-between">
                <div class="text-xl font-semibold  text-slate-700  text-justify">
                  My details
                </div>
                <div 
                class="filter-bar-button hover:opacity-75 focus:outline-none pt-2 cursor-pointer" @click="showTeacherEdit = true">
                  Edit User
                </div>
              </div>

              <div class="flex items-center space-x-4 justify-between">
                <div class="flex-column gap-3 space-y-1">
                  <div class="flex space-x-3 items-center">
                    <div
                    class="rounded-full bg-gray-200 h-12 w-12"
                     ></div>
                    <div class="text-lg font-bold">{{ user.name }}</div>
                  </div>

                </div>
                
              </div>

              <div class="flex items-center space-x-4 justify-between">
                <div class="flex-column gap-3 space-y-3">
             
                  <div class="text-grey-500 flex flex-row space-x-3 pt-2">
                    <div class="text-gray-500 text-xs w-24">Email (username):</div>
                    <div class="font-bold">{{ user.email }}</div>
                  </div>

                  <div class="text-grey-500 flex flex-row space-x-3">
                    <div class="text-gray-500 text-xs w-24">
                      Account Type:
                    </div>
                    <div class="font-bold">{{ parseAccountType }}</div>
                  </div>
</div>
              </div>

            </div>
          </div>
        </div>



        <div
          class="my-8 pl-10 w-[680px]  group sm:flex space-x-6  
           bg-white rounded-2xl p-6 mt-6 mx-auto w-10/12"
        >
          <div class="sm:w-full pl-0 p-2">
            <div class="space-y-4">
              <div class="flex justify-between">
                          <div class="text-xl font-semibold  text-slate-700  text-justify ">

                  School details
                </div>
                <div v-if="hasAdminAccess" 
                class="filter-bar-button hover:opacity-75 focus:outline-none pt-2 cursor-pointer" @click="showSchoolEdit = true">
                  Edit school
                </div>
              </div>
              <div class="flex items-center space-x-4 justify-between">
                <div class="flex-column gap-3 space-y-3">
                  <div class="text-base font-bold">{{ object.name }}</div>
                  <div class="text-grey-500 flex flex-row space-x-1 my-4">
                    <i
                      class="fas fa-map-marker-alt mr-2 text-lg text-blueGray-400"
                    ></i>
                    {{ object.address }}<br/>
                    {{ parseAddress }}
                  </div>
                  
                  <div class="text-grey-500 flex flex-row space-x-3 pt-2">
                    <div class="text-gray-500 text-xs w-32">Customer Number:</div>
                    <div class="font-bold">{{ parseCustomerNumber }}</div>
                  </div>

                  <div class="text-grey-500 flex flex-row space-x-3 pt-2">
                    <div class="text-gray-500 text-xs w-32">PE Contact:</div>
                    <div class="font-bold">{{ parsePeContact }}</div>
                  </div>

                  <div class="text-grey-500 flex flex-row space-x-3">
                    <div class="text-gray-500 text-xs w-32">
                      Finance Contact:
                    </div>
                    <div class="font-bold">{{ parseFinanceContact }}</div>
                  </div>

                  <div class="text-red-500 flex flex-row space-x-1 my-4 pt-2">
                    <div class="text-gray-500 text-xs w-32">Renewal Date:</div>
                    <i
                      class="fas fa-calendar-alt mr-2 text-lg text-blueGray-400"
                    ></i>&nbsp;
                    {{ parseRenewal }}
                  </div>
                </div>

                <div class="px-3 py-1 rounded-lg flex flex-row">
                  <div
                    class="cursor-pointer text-center text-md justify-center items-center flex hidden"
                  >
                    <img
                      src="https://flowbite.com/docs/images/people/profile-picture-1.jpg"
                      class="rounded h-20 w-20"
                    />
                  </div>
                </div>
              </div>
              <div class="flex items-center space-x-4 justify-between"></div>
            </div>
          </div>
        </div>
    </div>




  <ModalSlide :show="showSchoolEdit" @closeModal="closeSchoolEdit">
      <template v-slot:header-icon>
        <i class="fas fa-edit"></i>
      </template>
      <template v-slot:header-title>
       Edit school details
        <div class="text-xs">Enter school information.</div>
      </template>
      <template v-slot:body>
        <SchoolEdit v-if="object.id > 0" :school="object"  @school-edited="schoolEdited"></SchoolEdit>
      </template>
    </ModalSlide>



  <ModalSlide :show="showTeacherEdit" @closeModal="closeUserEdit">
      <template v-slot:header-icon>
        <i class="fas fa-edit"></i>
      </template>
      <template v-slot:header-title>
       Edit user details
        <div class="text-xs">Enter user information.</div>
      </template>
      <template v-slot:body>
        <TeacherEdit v-if="user.id > 0" :teacher="user"  @teacher-edited="userEdited"></TeacherEdit>
      </template>
    </ModalSlide>



  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { BaseService } from "@/services/school.service";
import { teacherTypeMixin } from "@/mixins/teacherTypeMixin.js";

const innertopbar = () => import("@/components/InnerTopBar.vue");
const ModalSlide = () => import("@/components/ModalSlide.vue");
const SchoolEdit = () => import("@/components/admin/TheSchoolEdit.vue");
const TeacherEdit = () => import("@/components/admin/TheTeacherEdit.vue");

export default {
  name: "myaccount",
  mixins: [teacherTypeMixin],

  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    showForSchool() {
      return this.currentUser.isSchool;
    },
    showForCompany() {
      return this.currentUser.isSchool == false;
    },
    hasAdminAccess() {
      return this.currentUser.hasAdmin;
    },
    parseAddress() {
      let city = this.object.city != undefined ?  this.object.city : "";
      let county = this.object.county != undefined ? ", " + this.object.county : ""
      let postcode = this.object.postcode != undefined ? ", " + this.object.postcode : "";

      return city + county + postcode;
    },
    parseFinanceContact() {
      return this.object.finance_contact != undefined
        ? this.object.finance_contact
        : "No contact set";
    },
    parseCustomerNumber() {
      return (this.object.customer_number != undefined && this.object.customer_number.length > 0)
          ? this.object.customer_number
          : "No customer number set"
    },
    parsePeContact() {
      return this.object.pe_contact != undefined
        ? this.object.pe_contact
        : "No contact set";
    },
    parseRenewal() {
      let date = moment(this.object.renewal_date);
      return date > moment()
        ? date.format("Do MMMM YYYY")
        : "Subscription overdue";
    },
    parseAccountType() {
      if (this.user.id != undefined) {
        var type =  this.teacherType(this.user.usertype_id)
        return type.name;
      }
    }
  },
  data() {
    return {
      object: {},
      user: {},
      loading: true,
      errored: false,
      showSchoolEdit: false,
      showTeacherEdit: false
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      BaseService.get("owner/school")
        .then((response) => this.parseSchool(response.data))
        .catch((err) => {
          console.log("Events " + err);
          this.errored = true;
        })
        .finally(() => (this.fetchUser()));
    },
    fetchUser() {
      BaseService.get("owner")
        .then((response) => this.user = response.data)
        .catch((err) => {
          console.log("Events " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    parseSchool(data) {
      this.object = data;
    },
    closeSchoolEdit() {
      this.showSchoolEdit = false
    },
    schoolEdited() {
      this.closeSchoolEdit()
    },
    closeUserEdit() {
      this.showTeacherEdit = false
    },
    userEdited() {
      this.closeUserEdit()
    },
    close() {
      this.$router.push("/");
    },
        logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
  components: {
    ModalSlide,
    SchoolEdit,
    TeacherEdit,
    innertopbar
  },
};
</script>
<style lang="css" scoped>
.form-label {
  @apply block uppercase tracking-wide text-gray-700 text-xs font-bold  mb-2;
}

.form-input {
  @apply appearance-none block w-full  bg-gray-100  text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight;
}
</style>
